import React, { Component, Fragment } from 'react';
import { TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export default class Email extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorText: props.errorText,
            error: props.error,
            defaultValue: props.defaultValue,
            focus: false,

            emailValue: '',
            isValid: true,
            errorTextMultipleEmails: ''
        };
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    UNSAFE_componentWillReceiveProps(next_props) {
        if (next_props.initial !== undefined && next_props.initial) {
            this.setState({ error: next_props.error, errorText: '', defaultValue: next_props.defaultValue });
        } else {
            this.setState({ error: next_props.error });
        }
    }

    handleChange = (event) => {
        this.setState({ defaultValue: event.target.value });
        if (event.target.value === '' && this.props.emailsarray === "true") {
            this.setState({ errorText: '', error: false });
        } else if (event.target.value === '') {
            this.setState({ errorText: 'Introduzca una dirección de correo electrónico', error: true });
        } else if (event.target.value !== '' && this.props.emailsarray === "true") {
            // IF emails varios concatenados
            const isValid = this.validateEmails(event.target.value);
            this.setState({ errorText: isValid ? this.state.errorTextMultipleEmails : '', error: isValid });
        } else {
            // ELSE email unico
            if (event.target.value.match(/^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/)) {
                this.setState({ errorText: '', error: false });
            } else {
                this.setState({ errorText: 'Ingrese un email válido.', error: true });
            }
        }
    }

    validateEmails = (emails) => {
        const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
        const emailList = emails.split(',').map(email => email.trim());
        this.setState({ errorTextMultipleEmails: emailList.length > 1 ? 'Ingrese un email válido' : 'Cada email debe estar separado por coma' })

        for (let email of emailList) {
            if (!emailRegex.test(email)) {
                return true;
            }
        }
        return false;
    };

    onBlur() { setTimeout(() => { if (this.state.focus) { this.setState({ focus: false }); } }, 0) }

    onFocus() { if (!this.state.focus) { this.setState({ focus: true }); } }

    render() {
        const OnFocusHideFixedElements = withStyles({
            "@global": {
                "body .headroom": { '@media (max-width: 960px)': { transform: "translate3d(0px, -100%, 0px)!important" } }
            }
        })(() => null);
        return (
            <Fragment>
                {this.state.focus && <OnFocusHideFixedElements />}
                <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    className={`TextField-Email ${this.props.classNameCustom}`}
                    size={this.props.size}
                    variant="outlined"
                    error={this.state.error}
                    id={this.props.id}
                    label={this.props.label}
                    placeholder={this.props.placeholder}
                    helperText={this.state.errorText}
                    onChange={this.handleChange}
                    value={this.state.defaultValue}
                    name={this.props.name}
                    disabled={this.props.disabled}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    required={this.props.required}
                    autoComplete={this.props.autoComplete}
                    emailsarray={this.props.emailsarray}
                />
                {this.state.emailValue &&
                    <div style={{ color: 'red' }}>Error</div>
                }
            </Fragment>
        )
    };
};
